var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main-content-layout',{attrs:{"title":_vm.$gettext('COMMUNICATION_HISTORY')}},[_c('div',{staticClass:"communication-history-page tw-p-5"},[_c('communication-history-grid',{attrs:{"consumer-unit":_vm.consumerUnitNumber}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }